import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as addImageActions from '@/admin/components/wysiwyg/addImage/Actions';
import * as errorHandlerActions from '@/components/errorHandler/Actions';
import { addWysiwygImageModalActionTypes } from '@/admin/components/wysiwyg/addImage/Constants';
import { processRequest } from '@/services/Api';

export default function* () {
	yield all([
		yield takeLatest(
			addWysiwygImageModalActionTypes.UPLOAD_WYSIWYG_IMAGE_REQUEST,
			handleUploadImageRequest,
		),
	]);
}

export function* handleUploadImageRequest(action) {
	try {
		const { data: formData, url, quill } = action.payload;

		const { data } = yield call(processRequest, url, 'GET', {
			content_type: formData.file.type,
		});
		const presignedUrl = data.signed_url;

		yield call(processRequest, presignedUrl, 'PUT', formData.file, true);

		const linkToFile = data.url || presignedUrl.split('?')[0];

		const val = {
			text: formData.caption,
			url: linkToFile,
		};

		const cursorPosition = quill.selection.savedRange.index;
		quill.insertEmbed(cursorPosition, 'figure', val, 'user');
		quill.setSelection(cursorPosition + 2);
		yield put(addImageActions.uploadImageSuccess());
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(addImageActions.uploadImageError());
	}
}
